import { useTranslation } from 'react-i18next'
import { Link, type LinkProps } from 'settle-ui/components/Link/Link'
import { openSupportContact, type OpenSupportContactParams } from 'routes/helpers/openSupportContact/openSupportContact'

interface SupportLinkProps extends OpenSupportContactParams {
  slotProps?: { root?: LinkProps }
  children?: string
}

export const SupportLink: React.FC<SupportLinkProps> = ({ children, slotProps, ...params }) => {
  const { t } = useTranslation()

  return (
    <Link variant="inherit" {...slotProps?.root} onClick={() => openSupportContact(params)}>
      {children || t('contactSupport')}
    </Link>
  )
}
